import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GetInvolved from "../pages/get-involved/page";
import Contact from "../pages/contact/page";
import PartnersAndDonors from "../pages/partners-donors/page";
import BrandPartners from "../pages/partners-donors/brand-partners/page";
import EkaFoundation from "../pages/eka-foundation/page";
import About from "../pages/about/page";
import OurTeam from "../pages/our-team/page";
import OurWork from "../pages/our-work/page";
import Health from "../pages/our-work/health/page";
import Education from "../pages/our-work/education/page";
import EconomicSecurity from "../pages/our-work/economic-security/page";
import Protection from "../pages/our-work/protection/page";
import News from "../pages/news/page";
import ArticleDetail from "../pages/news/detail/page";
import ProjectDetail from "../pages/projects/detail/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/page";
import AdminArticles from "../pages/admin/articles/page";
import AdminProjects from "../pages/admin/projects/page";
import AdminUsers from "../pages/admin/users/page";
import AdminInternsVolunteers from "../pages/admin/interns-volunteers/page";
import AdminSettings from "../pages/admin/settings/page";
import Donate from "../pages/donate/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/get-involved",
    element: <GetInvolved />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/partners-donors",
    element: <PartnersAndDonors />,
  },
  {
    path: "/partners-donors/brand-partners",
    element: <BrandPartners />,
  },
  {
    path: "/eka-foundation",
    element: <EkaFoundation />,
  },
  {
    path: "/our-team",
    element: <OurTeam />,
  },
  {
    path: "/our-work",
    element: <OurWork />,
  },
  {
    path: "/our-work/health",
    element: <Health />,
  },
  {
    path: "/our-work/education",
    element: <Education />,
  },
  {
    path: "/our-work/economic-security",
    element: <EconomicSecurity />,
  },
  {
    path: "/our-work/protection",
    element: <Protection />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/:id",
    element: <ArticleDetail />,
  },
  {
    path: "/projects/:id",
    element: <ProjectDetail />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/articles",
    element: <AdminArticles />,
  },
  {
    path: "/admin/projects",
    element: <AdminProjects />,
  },
  {
    path: "/admin/users",
    element: <AdminUsers />,
  },
  {
    path: "/admin/interns-volunteers",
    element: <AdminInternsVolunteers />,
  },
  {
    path: "/admin/settings",
    element: <AdminSettings />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
